import { useOfferingType } from '@/hooks/useOfferingType';
import { ProductFeedImports } from './FeedImports.product';
import { ServiceInventoryImport } from './FeedImports.service';

/**
 * Thin router that delegates to the correct feed-import view
 * based on the selected site's offering_type.
 *
 * - 'product' (default) -> ProductFeedImports  (original 4,200-line component)
 * - 'service'           -> ServiceInventoryImport (service inventory upload)
 * - 'mixed'             -> Both stacked vertically
 */
export default function FeedImports() {
  const offeringType = useOfferingType();

  switch (offeringType) {
    case 'service':
      return <ServiceInventoryImport />;
    case 'mixed':
      return (
        <div className="space-y-8">
          <div>
            <h2 className="text-lg font-semibold mb-4">Product Feed Imports</h2>
            <ProductFeedImports />
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-4">Service Inventory Import</h2>
            <ServiceInventoryImport />
          </div>
        </div>
      );
    case 'product':
    default:
      return <ProductFeedImports />;
  }
}
